import CardClipComponent from "../CommonComponents/CardClipComponent/CardClipComponent";
import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import {useClipMamSelected} from "../../contexts/clipMamSelected";
import {Clip, Highlight} from "../../types/clipTypes";


interface ClipComponentProps {
    clip: any;
    handleVideoPlayerUrl: (url: string) => void;
    handleOpenVideoPlayerUrl: (open: boolean) => void;
    deleteClip : (idClipGroups: string) => void;
    addClipGroup : (idClipGroups: string) => void;
    originalVideoContent?: Clip | Highlight
}


export default function ClipComponent({clip, deleteClip, handleOpenVideoPlayerUrl, handleVideoPlayerUrl, addClipGroup, originalVideoContent}: ClipComponentProps) {

    const {isClipInContext} = useClipMamSelected()

    return(
        <Box sx={{ position: 'relative' }}>
        <CardClipComponent  originalVideoContent={originalVideoContent} groupClip={clip} isChecked={isClipInContext(clip.id)} deleteClip={deleteClip} handleVideoPlayerURL={handleVideoPlayerUrl} handleOpenVideoPlayerURL={handleOpenVideoPlayerUrl} addGroupClip={addClipGroup}/>

        </Box>);

}